










import { defineComponent } from '@vue/composition-api';

import { toCommaFormat } from '@/utils';

const HorizontalBarChart = defineComponent({
  props: {
    data: {},
    xAxisLabel: { default: 'เดือน' },
    yAxisLabel: { default: 'จำนวนวัน' },
    height: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const options = {
      indexAxis: 'y',
      scales: {
        x: {
          title: {
            display: true,
            text: props.xAxisLabel,
          },
          ticks: {
            callback: (value: number) => `${toCommaFormat(value, 0, 0)}`,
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: props.yAxisLabel,
          },
          ticks: {
            maxRotation: 90,
            minRotation: 90,
          },
        },
      },
      plugins: {
        legend: {
          position: 'top',
          align: 'center',
        },
      },
    };

    return {
      options,
    };
  },
});

export default HorizontalBarChart;
